import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Nav } from "../components/Nav";
import { Footer } from "../components/Footer";
import { Reveal, Eyebrow } from "../components/Reveal";
import { LEGAL_DOCS } from "../data/legal";

export default function LegalPage({ doc }) {
  const d = LEGAL_DOCS[doc];
  useEffect(() => {
    document.title = `${d.title} — InSight Metabolics`;
    return () => {
      document.title = "InSight Metabolics — A Precision Metabolic & Lifestyle Clinic";
    };
  }, [d.title]);

  return (
    <div data-testid={`legal-${doc}-page`}>
      <Nav />
      <main className="bg-ivory grain relative">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 pt-36 pb-24">
          <Reveal>
            <Eyebrow>InSight Metabolics · Legal</Eyebrow>
            <h1 className="mt-6 font-serif font-medium text-forest text-3xl sm:text-4xl lg:text-5xl tracking-tight" data-testid="legal-title">
              {d.title}
            </h1>
            <p className="mt-3 font-mono text-[11px] tracking-[0.2em] uppercase text-inkmuted">{d.updated}</p>
            <p className="mt-8 text-inkmuted leading-relaxed">{d.intro}</p>
            <div className="mt-10 space-y-9">
              {d.sections.map((s) => (
                <section key={s.heading}>
                  <h2 className="font-serif text-xl sm:text-2xl text-ink mb-3">{s.heading}</h2>
                  {s.paragraphs.map((p, i) => (
                    <p key={i} className="text-inkmuted leading-relaxed text-[15px] mb-3">{p}</p>
                  ))}
                </section>
              ))}
            </div>
            <Link to="/" className="mt-14 inline-flex items-center gap-2 text-sm font-semibold text-forest hover:text-gold transition-colors" data-testid="legal-back-home">
              <ArrowLeft size={15} /> Back to InSight Metabolics
            </Link>
          </Reveal>
        </div>
      </main>
      <Footer />
    </div>
  );
}
